export default __webpack_public_path__ + "static/media/dan-saks.db00fc60.png";